import { PublicCartPaymentMethodResponse } from '../api/response/public-cart-payment-method.response';
import { PublicCartPaymentMethod } from '../models/public-cart-payment-method';
import { executeOrNull } from '@web/utils';
import { multimediaFromResponse } from '@web/shared/module/multimedia';
import { publicPaymentMethodPropertyFromResponse } from './public-payment-method-property-from-response';

export const publicPaymentMethodFromResponse = (
  response: PublicCartPaymentMethodResponse,
) => {
  return new PublicCartPaymentMethod({
    description: response.description,
    id: response.id,
    name: response.name,
    code: response.code,
    previewFile: executeOrNull(response.previewFile, (image) =>
      multimediaFromResponse(image),
    ),
    properties: response.properties.map((property) =>
      publicPaymentMethodPropertyFromResponse(property),
    ),
  });
};
